import { useCallback } from "react";
import { Row, Col } from "antd";
import { FormattedMessage, useIntl } from "react-intl";

import data from "./banks.json";
import SelectItem from "../../../../app/generic/form/selectItem";
import InputNumberItem from "../../../../app/generic/form/inputNumberItem";
import SelectItemWithLoad from "../../../../app/generic/form/selectItemWithLoad";

export const bankAccountPrefixName = "bankAccountPrefix",
  bankAccountName = "bankAccount",
  bankCodeName = "bankCode";

const prefixWeights = [10, 5, 8, 4, 2, 1],
  accountWeights = [6, 3, 7, 9, 10, 5, 8, 4, 2, 1];

const updatedData = data.map((b) => ({ ...b, name: `${b.code} > ${b.name}` }));

const validate = (number, weights) =>
  number &&
  [...number.toString()]
    .map((c, i) => Number.parseInt(c) * weights[i])
    .reduce((a, b) => a + b, 0) %
    11 ===
    0;

const NationalAccount = ({ formItemLayout }) => {
  const intl = useIntl();

  const handleValidation = useCallback(
    (value, account = true) => {
      const message =
        (!account && !value) ||
        validate(value, account ? accountWeights : prefixWeights)
          ? ""
          : intl.formatMessage({
              id: `registration.bank.account${account ? "" : "Prefix"}.invalid`,
              defaultMessage: `${
                account ? "Číslo účtu" : "Předčíslí"
              } není validní`,
            });
      return message ? Promise.reject(new Error(message)) : Promise.resolve();
    },
    [intl]
  );

  const handlePrefixChange = useCallback(
    (_, value) => handleValidation(value, false),
    [handleValidation]
  );

  const handleAccountChange = useCallback(
    (_, value) => handleValidation(value),
    [handleValidation]
  );

  return (
    <Row>
      <Col xxl={6} xs={9}>
        <InputNumberItem
          inheritWidth
          min={11}
          max={999999}
          formItemLayout={formItemLayout}
          fieldName={bankAccountPrefixName}
          validatorFunction={handlePrefixChange}
          label={
            <FormattedMessage
              id="registration.bank.accountPrefix"
              defaultMessage="Předčíslí"
            />
          }
        />
      </Col>
      <Col offset={1} xxl={11} xs={14}>
        <InputNumberItem
          inheritWidth
          min={111}
          wrapperCol={24}
          max={9999999999}
          fieldName={bankAccountName}
          formItemLayout={formItemLayout}
          validatorFunction={handleAccountChange}
          label={
            <FormattedMessage
              id="registration.bank.account"
              defaultMessage="Číslo účtu"
            />
          }
          message={
            <FormattedMessage
              id="registration.bank.account.empty"
              defaultMessage="Číslo účtu je povinné"
            />
          }
        />
      </Col>
      <Col xxl={6} xs={24}>
        <SelectItemWithLoad
          icon
          options={updatedData}
          errorMessage={
            <FormattedMessage
              id="registration.bank.code.loadError"
              defaultMessage="Při načítání bank nastala chyba"
            />
          }
        >
          <SelectItem
            allowClear
            showSearch
            options={updatedData}
            fieldName={bankCodeName}
            formItemLayout={formItemLayout}
            label={
              <FormattedMessage
                id="registration.bank.code"
                defaultMessage="Kód banky"
              />
            }
            message={
              <FormattedMessage
                id="registration.bank.code.empty"
                defaultMessage="Vyberte prosím kód banky"
              />
            }
          />
        </SelectItemWithLoad>
      </Col>
    </Row>
  );
};

export default NationalAccount;
